import angular from 'angular';

import DocumentService from '@/shared/services/DocumentService';
import { isEditable } from '@/shared/utils/mime';

angular.module('cloudX').directive('cxDocumentsDropdown', [
  function() {
    return {
      restrict: 'E',
      template: `
      <div class="dropdown documents-dropdown"
           ng-show="(vm.documents && vm.documents.length>0) || (('Documents:c'|security) && vm.showUpload)">
           <document-details-modal ng-if="vm.showPreview"
                            document-id="vm.activeDocument.id"
                            show="true"
                            on-close="vm.onPreviewClosed"
                            on-save="vm.onPreviewSaved">
            </document-details-modal>
        <a  data-toggle="dropdown"
            class="btn btn-xs btn-icon toggle-button"
            aria-haspopup="true">
          <i class="fa fa-paperclip"></i>
          <span class="badge" ng-show="vm.documents && vm.documents.length>0" ng-bind="vm.documents.length"></span>
          <span class="caret" ng-hide="vm.documents && vm.documents.length>0"></span>
        </a>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
          <li ng-if="('Documents:c'|security) && vm.showUpload" class="flex-menu-item">
            <a file-upload
               onclick="this.blur();"
               upload="vm.uploadFiles(files)">
              <i class="fa fa-upload fa-fw"></i>
              <span class="flex-item" data-translate="UploadDocument"></span>
            </a>
          </li>
          <li ng-if="('Documents:c'|security) && vm.showUpload && vm.documents.length>0" role="separator" class="divider"></li>
          <li ng-repeat="document in vm.documents" ng-if="!!vm.documents" class="flex-menu-item">
            <a id="document-{{document.id}}-Download"
               cx-security="'Documents:r'"
               ng-click="vm.previewDocument(document)">
              <i ng-class="document.mime | mimeIcon"></i>
              <i class="fa fa-spinner fa-spin"
                   ng-show="document.showSpinner"></i>
              <span class="flex-item margin5L margin5R">{{document.name}}</span>
              <span class="margin5L margin5R"
                    ng-if="vm.showDocumentType && document.documentType"
                    title="{{('DocumentType'|translate)}} : {{document.documentType|translateList:'documentType'}}">
                <span>({{document.documentType|translateList:'documentType'}})</span>
              </span>
              <i class="fa fa-external-link clickable margin5L"
                 ng-click="vm.openInApp(document, $event)"
                 ng-if="document.canEdit && document.storageType === 1"
                 title="Open in app"
                 cx-security="'Documents:u'"></i>
              <i class="fa fa-edit clickable margin5L"
                 ng-if="vm.showEditIcon(document)"
                 ng-click="vm.edit(document, $event)"
                 title="Edit"
                 cx-security="'Documents:u'"></i>
              <i class="fa fa-trash clickable margin5L"
                 ng-click="vm.deleteDocument(document, $event)"
                 cx-security="'Documents:d'"></i>
              </a>
            <span id="document-{{document.id}}-Download"
                  ng-if="!('Documents:r'|security)">
              <i ng-class="document.mime | mimeIcon"></i>
              {{document.name}}
            </span>
          </li>

        </ul>
      </div>`,
      replace: true,
      scope: {
        documents: '=',
        showUpload: '=',
        linkType: '=?',
        linkId: '=?',
        onUpload: '&?',
        onDeleteLink: '&?',
        showDocumentType: '=?',
      },
      bindToController: true,
      controllerAs: 'vm',
      controller: [
        '$http',
        'appUrls',
        'flySvc',
        'dialogsSvc',
        '$timeout',
        '$q',
        '$translate',
        function($http, appUrls, flySvc, dialogsSvc, $timeout, $q, $translate) {
          const vm = this;
          if (!vm.onUpload) vm.showUpload = false;

          vm.uploadFiles = function(files) {
            if (!vm.onUpload) return;
            vm.onUpload({ files: files });
          };
          vm.edit = async function(document, event) {
            event.stopPropagation();

            if (document.storageType === 1) {
              window.open(document.path, '_blank');
              return;
            }

            await DocumentService.edit(document.id, $translate.use().split('-')[0]);
          };
          vm.openInApp = async function(document, event) {
            event.stopPropagation();

            await DocumentService.openInApp(document.id);
          };

          vm.onPreviewClosed = () => {
            $timeout(function() {
              vm.showPreview = false;
              vm.activeDocumentId = null;
            }, 0);
          };

          vm.onPreviewSaved = document => {
            $timeout(function() {
              vm.showPreview = false;
              vm.activeDocument = null;
              vm.documents = vm.documents.map(x => {
                if (x.id === document.id) {
                  return {
                    ...x,
                    ...document,
                  };
                }
                return x;
              });
            }, 0);
          };

          vm.previewDocument = document => {
            vm.activeDocument = document;
            vm.showPreview = true;
          };

          vm.showEditIcon = document => {
            const fileExtension = document.name.split('.').pop();
            return isEditable(fileExtension, document.mime);
          };

          vm.download = function(document) {
            if (!document || !document.id) return;
            if (document.showSpinner) return;
            document.showSpinner = true;
            DocumentService.download(document.id).finally(() => {
              $timeout(function() {
                document.showSpinner = false;
              }, 0);
            });
          };

          vm.sendDeleteDocumentRequest = function(documentId) {
            return $http.delete(`${appUrls.documents}/api/documents/${documentId}`);
          };
          vm.sendDeleteDocumentLinkRequest = function(documentId) {
            if (!vm.linkId || !vm.linkType) return $q.reject();

            return $http.delete(
              `${appUrls.documents}/api/documents/Links/${documentId}/${vm.linkId}/${vm.linkType}`,
            );
          };

          vm.deleteDocument = function(document, event) {
            event.stopPropagation();
            if (document.showSpinner) return;
            if (vm.linkId && vm.linkType) {
              return dialogsSvc
                .showYesNoCancel('comfirmDeleteTitle', 'msgConfirmDeleteDocumentOrLink')
                .then(function(confirm) {
                  if (confirm === null) return false; //cancel
                  document.showSpinner = true;
                  const request = confirm
                    ? vm.sendDeleteDocumentRequest(document.id)
                    : vm.sendDeleteDocumentLinkRequest(document.id);

                  return request
                    .then(function(response) {
                      var result = response.data;
                      flySvc.success();
                      var index = vm.documents.indexOf(document);
                      if (index >= 0) vm.documents.splice(index, 1);
                      document.showSpinner = false;
                    })
                    .catch(function(error) {
                      flySvc.error(error);
                      document.showSpinner = false;
                      return '';
                    });
                });
            }
            return dialogsSvc
              .showYesNo('comfirmDeleteTitle', 'msgConfirmDeleteDocument')
              .then(function() {
                document.showSpinner = true;

                return vm
                  .sendDeleteDocumentRequest(document.id)
                  .then(function(response) {
                    var result = response.data;
                    flySvc.success();
                    var index = vm.documents.indexOf(document);
                    if (index >= 0) vm.documents.splice(index, 1);
                    document.showSpinner = false;
                  })
                  .catch(function(error) {
                    flySvc.error(error);
                    document.showSpinner = false;
                    return '';
                  });
              });
          };
        },
      ],
    };
  },
]);
